<template>
  <div>
    <div class="title">
      <div class="warp">
        <p>智能指纹密码器Y01P</p>
        <el-radio-group v-model="radio" @input="getValue">
          <el-radio label="1">详情</el-radio>
          <el-radio label="2">参数</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="container">
      <div v-show="show">
        <div style="overflow: hidden" class="sdevice hidden-md-and-down">
          <ul>
            <li>
              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器1.jpg"
                alt=""
              />
            </li>
            <li ref="element1">
              <div
                class="commodity animate__animated animate__fadeInUp"
                v-show="productImgShow"
                style="top: 8%"
              >
                <p style="color: #633b1c; font-size: 4.125rem">
                  选择指纹密码器的6大理由
                </p>
              </div>
              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器2.jpg"
                alt=""
              />
            </li>
            <li ref="element2">
              <div
                class="commodity animate__animated animate__fadeInUp"
                v-show="productImgShow2"
                style="top: -4%"
              >
                <p>是否遇到忘记密码带来的烦恼和不便？</p>
              </div>
              <div
                class="commodity navList animate__animated animate__fadeInUp animate__delay-700ms 700ms"
                v-show="productImgShow2"
              >
                <p class="p1">
                  <span>长时间不用遗忘</span>
                </p>
                <p class="p2">
                  <span>密码复杂不易记忆</span>
                </p>
                <p class="p3">
                  <span>密码改来改去</span>
                </p>
                <p class="p4">
                  <span>各种应用密码太多</span>
                </p>
              </div>
              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器3.jpg"
                alt=""
              />
            </li>
            <li ref="element3">
              <div
                class="commodity animate__animated animate__fadeInUp title5"
                v-show="productImgShow3"
              >
                <div
                  style="width: 38.0625rem; font-size: 2.75rem; color: white"
                >
                  <h3
                    style="
                      color: #633b1c;
                      background-color: #f1ede8;
                      border-radius: 5.125rem;
                      font-size: 2.75rem;
                      text-align: center;
                      padding: 1.125rem 1.6875rem;
                    "
                  >
                    您需要一台智能指纹密码器
                  </h3>
                  <h2 style="font-size: 66px">密码一站式管理</h2>
                  <p style="font-size: 2.5625rem">无论是手机APP密码</p>
                  <p style="font-size: 2.5625rem">还是电脑密码</p>
                  <p style="font-size: 2.5625rem">APP一站式管理</p>
                </div>
              </div>
              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器4.jpg"
                alt=""
              />
            </li>
            <li ref="element4">
              <div
                style="width: 38%"
                class="commodity animate__animated animate__fadeInUp title2"
                v-show="productImgShow4"
              >
                <p style="width: 100%; margin-bottom: 2.9375rem">
                  指纹一触登录电脑应用
                </p>
                <span
                  style="
                    background: #f1ede8;
                    border-radius: 2.4375rem;
                    padding: 0.3125rem;
                    color: #633b1c;
                  "
                  class="animate__animated animate__fadeInUp animate__delay-700ms 700ms"
                  >通过APP添加电脑登录密码、电脑客户端<br />
                  和电脑网站账号后，即可使用指纹一触登录</span
                >
              </div>
              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器5.jpg"
                alt=""
              />
            </li>
            <li ref="element5">
              <div
                class="commodity animate__animated animate__fadeInUp"
                v-show="productImgShow5"
                style="top: 0;"
              >
                <p>支持各类应用智能填充登录</p>
                <span
                  class="animate__animated animate__fadeInUp animate__delay-700ms 700ms"
                  >兼容电脑主流浏览器、操作系统、覆盖您日常使用的各种登录场景</span
                >
              </div>

              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器13.jpg"
                alt=""
              />
            </li>
            <li ref="element6">
              <div
                class="commodity animate__animated animate__fadeInUp"
                v-show="productImgShow6"
                style="top: 0;"
              >
                <p>电脑文件加解密</p>
                <span
                  class="animate__animated animate__fadeInUp animate__delay-700ms 700ms"
                  >通过宇起助手将电脑文件加密，然后授权对方指纹解密查看，让保密文件更安全、更放心</span
                >
              </div>

              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器6.jpg"
                alt=""
              />
            </li>
            <li ref="element7">
              <div
                class="commodity animate__animated animate__fadeInUp"
                v-show="productImgShow7"
                style="top: -2%;"
              >
                <p>授权用户登录电脑</p>
                <span
                  class="animate__animated animate__fadeInUp animate__delay-1s 1s"
                  style="margin-left: 2.575vw"
                >
                  授权用户后，该用户直接使用指纹登录电脑，如管理会议室电脑
                </span>
              </div>
              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器7.jpg"
                alt=""
              />
            </li>
            <li ref="element8">
              <div
                class="commodity animate__animated animate__fadeInUp"
                v-show="productImgShow13"
              >
                <p>安全可靠 数据无忧</p>
                <span
                  class="animate__animated animate__fadeInUp animate__delay-500ms 500ms"
                >
                  密码器和APP采用高级加密技术，保障您的数据安全，让您放心使用。
                </span>
              </div>
              <div
                class="commodity navList animate__animated animate__fadeInUp"
                v-show="productImgShow11"
              ></div>
              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器8.jpg"
                alt=""
              />
            </li>
            <li ref="element9">
              <div
                class="commodity animate__animated animate__fadeInUp"
                v-show="productImgShow9"
                style="top: 10%"
              >
                <p>全面的加密模式，守护隐私安全</p>
              </div>

              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器9.jpg"
                alt=""
              />
            </li>
            <li ref="element10">
              <div
                class="commodity animate__animated animate__fadeInUp title3"
                v-show="productImgShow10"
                style="top: 0%"
              >
                <p style="">科技时尚外观</p>
                <p
                  class="animate__animated animate__fadeInUp animate__delay-1s 1s"
                  style="color: #bea167; font-size: 2.25rem"
                >
                  设备外观精致小巧，可以轻松融入您的办公环境中。
                </p>
              </div>

              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器10.jpg"
                alt=""
              />
            </li>
            <li ref="element11">
              <div
                class="commodity animate__animated animate__fadeInUp"
                v-show="productImgShow18"
              >
                <p style="color: #633b1c; ">
                  宇起APP智能管理，轻松办公
                </p>
                <span
                  style="color: #bea167; "
                  class="animate__animated animate__fadeInUp animate__delay-1s 1s"
                  >我们的专用APP提供高效、智能的软件服务，帮助您轻松管理您的密码器，<br />
                  让您的办公体验更贴心、更便捷。</span
                >
              </div>
              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器11.jpg"
                alt=""
              />
            </li>
            <li>
              <img
                style="width: 100%"
                src="../../assets/mock/Y05/密码器12.jpg"
                alt=""
              />
            </li>
          </ul>
        </div>
      </div>
      <div style="min-height: 80vh" v-show="show" class="hidden-lg-and-up">
        <img
          style="width: 100%; min-height: 80vh"
          src="../../assets/mock/Y05/Apple.jpg"
          alt=""
        />
      </div>
      <div v-show="!show">
        <img style="width: 100%" src="../../assets/mock/Y05/12.jpg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      radio: "1",
      show: true,
      productImgShow: false,
      productImgShow2: false,
      productImgShow3: false,
      productImgShow4: false,
      productImgShow5: false,
      productImgShow6: false,
      productImgShow7: false,
      productImgShow9: false,
      productImgShow10: false,
      productImgShow11: false,
      productImgShow13: false,
      productImgShow18: false,
      observer: null, // Intersection Observer 实例
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initIntersectionObserver();
    });
  },
  methods: {
    getValue(value) {
      if (value == 1) {
        this.show = true;
        // 当切换回详情页时，重新初始化观察器
        this.$nextTick(() => {
          this.initIntersectionObserver();
        });
      } else {
        this.show = false;
        // 清理观察器
        this.destroyObserver();
      }
    },
    initIntersectionObserver() {
      // 清理旧的观察器
      this.destroyObserver();
      
      // 创建 Intersection Observer，设置阈值为 0.3（30%）
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
              // 根据元素的 ref 名称设置对应的显示状态
              const elementRef = entry.target.getAttribute("data-ref");
              if (elementRef && !this[elementRef]) {
                this[elementRef] = true;
              }
            }
          });
        },
        {
          threshold: 0.3, // 当元素进入视口30%时触发
          rootMargin: "0px",
        }
      );

      // 观察所有需要动画的元素
      const elements = [
        { ref: this.$refs.element1, show: "productImgShow" },
        { ref: this.$refs.element2, show: "productImgShow2" },
        { ref: this.$refs.element3, show: "productImgShow3" },
        { ref: this.$refs.element4, show: "productImgShow4" },
        { ref: this.$refs.element5, show: "productImgShow5" },
        { ref: this.$refs.element6, show: "productImgShow6" },
        { ref: this.$refs.element7, show: "productImgShow7" },
        { ref: this.$refs.element8, show: "productImgShow13" },
        { ref: this.$refs.element9, show: "productImgShow9" },
        { ref: this.$refs.element10, show: "productImgShow10" },
        { ref: this.$refs.element11, show: "productImgShow18" },
      ];

      elements.forEach((item) => {
        if (item.ref) {
          item.ref.setAttribute("data-ref", item.show);
          this.observer.observe(item.ref);
        }
      });
    },
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
  },
  beforeDestroy() {
    this.destroyObserver();
  },
};
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  position: absolute;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  div {
    p {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 3.25rem;
  }
}
@media only screen and (max-width: 992px) {
  .title {
    position: relative;
    p {
      font-size: 1rem !important;
    }
  }
}
.container {
  height: 100%;
  position: relative;
  .sdevice {
    ul {
      li {
        height: auto;
        position: relative;
        img {
          display: block;
        }
        p {
          margin: 0;
          width: 100vw;
          overflow: hidden;
        }
        .commodity {
          position: absolute;
          text-align: center;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #633b1c;
          font-size: 4.3125rem;
          top: 4%;
          transform: translate(-50%, -50%);
          p {
            font-size: 3.5938vw;
          }
          span {
            font-size: 1.8229vw;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #bea167;
            display: block;
            margin: 5px 0;
          }
          .box {
            top: 235%;
            left: 85%;
            text-align: left;
            img {
              width: 2.1875vw;
              height: auto;
              margin-right: 0.8604vw;
            }
            p {
              display: flex;
              font-size: 1.8229vw;
              margin: 1.7188vw 0;
              align-items: center;
              color: #000000;
            }
            color: #3cb59e;
          }
        }
        .title5 {
          position: absolute;
          top: 21%;
          left: 11%;
          text-align: left;

          p {
            padding-left: 1.6rem;
            width: 100%;
            margin: 1.25rem 0;
          }
          h2 {
            padding-left: 1.6rem;

            margin: 3.6875rem 0 2.25rem 0;
          }
        }
        .navList {
          height: 12.5rem;
          width: 100vw;
          p {
            width: 15.2917vw;
            height: 3.0729vw;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f1ede8;
            border-radius: 10.9333vw;
            padding: 5px 2.1354vw;

            img {
              display: inline;
              margin-right: 1.0188vw;
            }
            span {
              font-size: 1.8229vw;
              font-weight: 500;
              color: #633b1c;
            }
          }
          .p1 {
            position: absolute;
            top: 109%;
            left: 15%;
          }
          .p2 {
            position: absolute;
            top: 231%;
            left: 60%;
          }
          .p3 {
            position: absolute;
            top: 238%;
            left: 18%;
          }
          .p4 {
            position: absolute;
            top: 329%;
            left: 63%;
          }
        }
        .navList ::after {
          content: "";
          display: block;
          clear: both;
        }
        .title2 {
          top: 12%;
          left: 51%;
        }
        .title3 {
          top: 5%;
        }
      }
    }
  }
}
::v-deep .el-radio__input {
  display: none;
}
::v-deep .el-radio__label {
  color: #fff;
}
</style>
